import { createContext, useContext } from 'react'

// The page's copy (content/customerAcquisition.js or content/raisingInvestment.js). Every section reads it
// here, so the two pages share one set of sections.
const FocusContext = createContext(null)

export const FocusProvider = FocusContext.Provider

export const useFocus = () => useContext(FocusContext)
